/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDName } from './IDName';
import {
    IDNameFromJSON,
    IDNameFromJSONTyped,
    IDNameToJSON,
    IDNameToJSONTyped,
} from './IDName';

/**
 * 
 * @export
 * @interface OrderPayment
 */
export interface OrderPayment {
    /**
     * 
     * @type {string}
     * @memberof OrderPayment
     */
    id: string;
    /**
     * 
     * @type {IDName}
     * @memberof OrderPayment
     */
    payment_method: IDName;
    /**
     * 
     * @type {number}
     * @memberof OrderPayment
     */
    net_amount: number;
}

/**
 * Check if a given object implements the OrderPayment interface.
 */
export function instanceOfOrderPayment(value: object): value is OrderPayment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('payment_method' in value) || value['payment_method'] === undefined) return false;
    if (!('net_amount' in value) || value['net_amount'] === undefined) return false;
    return true;
}

export function OrderPaymentFromJSON(json: any): OrderPayment {
    return OrderPaymentFromJSONTyped(json, false);
}

export function OrderPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPayment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'payment_method': IDNameFromJSON(json['payment_method']),
        'net_amount': json['net_amount'],
    };
}

export function OrderPaymentToJSON(json: any): OrderPayment {
    return OrderPaymentToJSONTyped(json, false);
}

export function OrderPaymentToJSONTyped(value?: OrderPayment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payment_method': IDNameToJSON(value['payment_method']),
        'net_amount': value['net_amount'],
    };
}

